var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 24.75,
    viewBox: "0 0 24.75 24.75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.875a2 2 0 012-2h20.75a2 2 0 010 4H2a2 2 0 01-2-2zm22.75 6.5H2a2 2 0 000 4h20.75a2 2 0 000-4zm0 8.5H2a2 2 0 000 4h20.75a2 2 0 000-4z"
  })));
}

export default SvgIconMenu;